import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { QRCodeComponent } from 'angularx-qrcode';
import { SharedModule } from "lib-trend-core";
import { BaseComponent } from './base/base.component';
import { FooterComponent } from './footer.component';
import { HeaderComponent } from './header.component';
import { ImprovementRankingModalComponent } from './improvement-ranking-modal/improvement-ranking-modal.component';
import { LanguagePickerComponent } from './language-picker.component';
import { AboutModalComponent } from './about-modal/about-modal.component';
import { MobileAppModalComponent } from './mobile-app-modal/mobile-app-modal.component';
import { MobileAppPromoComponent } from './mobile-app-promo/mobile-app-promo.component';
import { PlansModalComponent } from './plans-modal/plans-modal.component';
import { SideBarComponent } from './sidebar.component';
import { TrialButtonComponent } from './trial-button/trial-button.component';
import { SoftphoneModule } from '../softphone/softphone.module';
import { ChatBubbleModule } from '../chat/chat-bubble/chat-bubble.module';

@NgModule({ declarations: [
        BaseComponent,
        HeaderComponent,
        LanguagePickerComponent,
        SideBarComponent,
        FooterComponent,
        PlansModalComponent,
        TrialButtonComponent,
        AboutModalComponent,
        MobileAppPromoComponent,
        MobileAppModalComponent,
        ImprovementRankingModalComponent,
    ],
    exports: [
        BaseComponent,
        HeaderComponent,
        LanguagePickerComponent,
        SideBarComponent,
        FooterComponent,
        PlansModalComponent,
        TrialButtonComponent,
        AboutModalComponent,
        MobileAppPromoComponent,
        MobileAppModalComponent,
    ], imports: [CommonModule,
        RouterModule,
        SharedModule,
        MatDialogModule,
        QRCodeComponent,
        SoftphoneModule,
        ChatBubbleModule], providers: [
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })

export class LayoutModule { }
